import React from "react";

export default function CartScreenCartHeader(props) {
  // PROPS COMING FROM CartScreenCart
  const { item } = props;

  const size = item?.size?.split("-")?.[1];
  const color = item?.color?.split("-")?.[1];

  return (
    <div className="greenbcklight marq padq">
      <h4 className="fs1125 txtleft marupsideh">{item.productName}</h4>
      <p>
        {size && `• ${size?.split("(")?.[0]?.slice(0, 8)}`}{" "}
        {color && `• ${color?.slice(0, 8)}`}
      </p>
    </div>
  );
}
